export default "__VITE_ASSET__B2aDf_61__"